import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { analytics } from "../firebase";
import { logEvent } from "firebase/analytics";

import { styles } from "../styles";
import { staggerContainer } from "../utils/motion";

const StarWrapper = (Component, idName) =>
  function HOC() {
    const startTimeRef = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            startTimeRef.current = Date.now();
          } else if (startTimeRef.current) {
            const endTime = Date.now();
            const durationSeconds = Math.round((endTime - startTimeRef.current) / 1000);
            
            if (durationSeconds > 1 && analytics) {
              logEvent(analytics, 'section_dwell_time', {
                section_id: idName,
                duration: durationSeconds
              });
            }
            startTimeRef.current = null;
          }
        },
        { threshold: 0.5 } // Track if at least 50% of the section is visible
      );

      const element = document.getElementById(idName);
      if (element) observer.observe(element);

      return () => {
        if (element) observer.unobserve(element);
        // Clean up: if component unmounts while in view, log the time
        if (startTimeRef.current) {
          const durationSeconds = Math.round((Date.now() - startTimeRef.current) / 1000);
          if (durationSeconds > 1 && analytics) {
            logEvent(analytics, 'section_dwell_time', {
              section_id: idName,
              duration: durationSeconds
            });
          }
        }
      };
    }, []);

    return (
      <motion.section
        variants={staggerContainer()}
        initial='hidden'
        whileInView='show'
        viewport={{ once: true, amount: 0.25 }}
        className={`${styles.padding} max-w-7xl mx-auto relative z-0`}
      >
        <span className='hash-span' id={idName}>
          &nbsp;
        </span>

        <Component />
      </motion.section>
    );
  };

export default StarWrapper;